module.exports = __webpack_public_path__ + "media/assets/images/blog/change_management-0f11846a83fd2e7690786304a6f74abd.png";